const ZONE_COLORS = [
  '#E57373', '#FFB74D', '#CFD8DC', '#81C784',
  '#CFD8DC', '#FFB74D', '#E57373',
];

export function buildZoneBands(domain, mean, sigma) {
  const [domainMin, domainMax] = domain;
  if (!Number.isFinite(domainMin) || !Number.isFinite(domainMax) || domainMin >= domainMax) {
    return [];
  }
  if (!Number.isFinite(sigma) || sigma <= 0) {
    return [{ from: domainMin, to: domainMax, color: '#81C784' }];
  }

  const edges = [
    -Infinity, mean - 3 * sigma, mean - 2 * sigma, mean - sigma,
    mean + sigma, mean + 2 * sigma, mean + 3 * sigma, Infinity,
  ];

  return ZONE_COLORS.map((color, index) => ({
    from: Math.max(domainMin, edges[index]),
    to: Math.min(domainMax, edges[index + 1]),
    color,
  })).filter((band) => band.from < band.to);
}
